import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d14fa32"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,UiModal: require('/vercel/path0/components/ui/modal.vue').default,UiIconStarEmpty: require('/vercel/path0/components/ui/icon/star-empty.vue').default,UiIconInfo: require('/vercel/path0/components/ui/icon/info.vue').default,ChefReviewCard: require('/vercel/path0/components/chef/review-card.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
